/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  AcknowledgeIncidentMutationRequest,
  AcknowledgeIncidentMutationResponse,
  AcknowledgeIncidentPathParams,
  AcknowledgeIncident401,
  AcknowledgeIncident404,
} from '../types/AcknowledgeIncident.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getAcknowledgeIncidentUrl(id: AcknowledgeIncidentPathParams['id']) {
  const res = { method: 'POST', url: `/v1/incidents/${id}/acknowledge` as const };
  return res;
}

/**
 * @summary Acknowledge an incident
 * {@link /v1/incidents/:id/acknowledge}
 */
export async function acknowledgeIncident(
  id: AcknowledgeIncidentPathParams['id'],
  data?: AcknowledgeIncidentMutationRequest,
  config: Partial<RequestConfig<AcknowledgeIncidentMutationRequest>> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    AcknowledgeIncidentMutationResponse,
    ResponseErrorConfig<AcknowledgeIncident401 | AcknowledgeIncident404>,
    AcknowledgeIncidentMutationRequest
  >({ method: 'POST', url: getAcknowledgeIncidentUrl(id).url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
